import { useState } from 'react';
import Segmented from '../../components/ui/Segmented';
import EngagementTab from './EngagementTab';
import WellbeingTab from './WellbeingTab';
import InterestsTab from './InterestsTab';
import ParentTab from './ParentTab';

type SubTabKey = 'engagement' | 'wellbeing' | 'interests' | 'family';

interface Props {
  id: number;
  cohort?: { gradeId: number | null; sectionId: number | null };
  gender?: string | null;
}

export default function WellbeingTabs({ id, cohort, gender }: Props) {
  const [active, setActive] = useState<SubTabKey>('engagement');
  return (
    <div className="space-y-4">
      <Segmented<SubTabKey> dense tabs scroll label="Wellbeing view"
        options={[
          { key: 'engagement', label: 'Engagement', help: 'Study time, feature usage and AI usage for this student.' },
          { key: 'wellbeing',  label: 'Wellbeing',  help: "The student's own wellbeing check-ins and latest state. Counsellors and admins see the detail; teachers see only the colour." },
          { key: 'interests',  label: 'Interests',  help: 'Career interests, predicted careers, aspirations and scholarship matches.' },
          { key: 'family',     label: 'Family',     help: 'The guardian on file and the weekly parent digest.' },
        ]}
        value={active}
        onChange={setActive}
      />
      {active === 'engagement' && <EngagementTab id={id} cohort={cohort} gender={gender} />}
      {active === 'wellbeing'  && <WellbeingTab id={id} gender={gender} />}
      {active === 'interests'  && <InterestsTab id={id} />}
      {active === 'family'     && <ParentTab id={id} />}
    </div>
  );
}
